import { useMutation, useQueryClient } from 'react-query';
import notify from '../../../../../../../shared/feedback/notifications';
import { handleError } from '../../../../../../../shared/ErrorCatching';
import { Translate } from '../../../../../../../shared/LanguageService';
import { AuthenticatedUser } from '../../../../../../../shared/types';
import { useTelemetryContext } from '../../../../../../../telemetry/telemetryContext';
import { getUserInfo } from '../../../../../../../telemetry/utils';
import ImageProcessingApi from '../../../api/ImageProcessingApi';
import { photoStatusQueryKey } from '../../entry/queries/use-query-photo-status';
import { imagesQueryKey } from '../../listImages/queries/use-query-images';

type DoneEditingMutationArgs = {
    orderId: number;
    user: AuthenticatedUser;
};

export function useDoneEditingMutation({ orderId, user }: DoneEditingMutationArgs) {
    let queryClient = useQueryClient();
    let { logger } = useTelemetryContext();

    return useMutation(() => ImageProcessingApi.doneEditingImages(orderId), {
        onSuccess: () => {
            notify.success(Translate('image-processing/page/status-actions/notification/success'));
            return Promise.all([
                queryClient.invalidateQueries([photoStatusQueryKey, { orderId }]),
                queryClient.invalidateQueries([imagesQueryKey, { orderId }])
            ]);
        },
        onError: (error) => {
            logger.logException(error, {
                origin: 'ImageEditorImageProcessingPage.Mutation.doneEditingImages',
                userInfo: getUserInfo(user)
            });
            handleError(error);
        }
    });
}
